import { PartnerDataFormKeys } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/configs'

import { IPartner } from 'clickNgo/entities/partner/models'
import { useGetFormData } from 'cng-common/features/form'

export const useHasChangesInForm = () => {
  const [{ modifiedFields: basicInfoModifiedFields }] = useGetFormData<IPartner>(
    PartnerDataFormKeys.BasicInfo
  )

  const [{ modifiedFields: legalInfoModifiedFields }] = useGetFormData<IPartner>(
    PartnerDataFormKeys.LegalInfo
  )

  const [{ modifiedFields: additionalInfoModifiedFields }] = useGetFormData<IPartner>(
    PartnerDataFormKeys.AdditionalInfo
  )

  const [{ modifiedFields: attachmentsModifiedFields }] = useGetFormData<IPartner>(
    PartnerDataFormKeys.Attachments
  )

  return {
    isFormChanged:
      basicInfoModifiedFields.length > 0 ||
      legalInfoModifiedFields.length > 0 ||
      additionalInfoModifiedFields.length > 0 ||
      attachmentsModifiedFields.length > 0,
  }
}
